import { List } from 'immutable';
import Base from 'records/Base';
import { mapToRecords } from 'records/SalesConsultant';
import {
  SALES_CONSULTANT_RESET_STATE,
  SALES_CONSULTANT_ASYNC_START,
  SALES_CONSULTANT_ASYNC_ERROR,
  SALES_CONSULTANT_ASYNC_SUCCESS,
} from 'actions/salesConsultant';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [SALES_CONSULTANT_RESET_STATE]: () => initialState,
  [SALES_CONSULTANT_ASYNC_START]: state =>
    state.merge({
      loading: true,
      errorMessage: null,
    }),
  [SALES_CONSULTANT_ASYNC_ERROR]: (state, action) =>
    state.merge({
      loading: false,
      errorMessage: action.payload.error,
    }),
  [SALES_CONSULTANT_ASYNC_SUCCESS]: (state, action) =>
    state.merge({
      loading: false,
      errorMessage: null,
      data: mapToRecords(action.payload.data),
    }),
}

export default function salesConsultant(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
